import i18n from '@/utils/i18n';
import React, { useMemo } from 'react';
import { Button, View } from '@usepepper/sprout-kit-ui';
import { ORDER_GUIDE_HEADER_ACTIONS_PORTAL_HOST } from '@/experiences/sales-portal/domain/order-guides/screens/order-guides-list/order-guides-list-constants';
import { Portal } from '@gorhom/portal';
import {
  useCurrentOrderGuideEditability,
  useEditOrderGuideState,
} from '@/experiences/sales-portal/domain/order-guides/blocs/contexts/edit-order-guide-context';

interface Props {
  onOpenAddItems: () => void;
  onOpenConvertToQuote: () => void;
}

export const OrderGuideHeaderActions: React.FC<Props> = ({
  onOpenAddItems,
  onOpenConvertToQuote,
}) => {
  const { partitions } = useEditOrderGuideState();
  const editability = useCurrentOrderGuideEditability();

  const hasConvertibleItems = useMemo(
    () =>
      partitions.some((partition) =>
        partition.itemGroups.some((group) => group.items.length > 0),
      ),
    [partitions],
  );

  const addItemLabel = i18n.t(
    'sales_portal.order_guides_list.add_items.list_row_label',
  );
  const convertToQuoteLabel = i18n.t(
    'sales_portal.order_guides_list.convert_to_price_quote.title',
  );

  return (
    <Portal hostName={ORDER_GUIDE_HEADER_ACTIONS_PORTAL_HOST}>
      <View alignItems="center" flexDirection="row" gap="$8">
        <Button
          accessibilityLabel={convertToQuoteLabel}
          disabled={!hasConvertibleItems}
          onPress={onOpenConvertToQuote}
          size="$md"
          variant="secondary"
        >
          {convertToQuoteLabel}
        </Button>
        {editability === 'editable' ? (
          <Button
            accessibilityLabel={addItemLabel}
            onPress={onOpenAddItems}
            size="$md"
          >
            {addItemLabel}
          </Button>
        ) : null}
      </View>
    </Portal>
  );
};
